import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

export default function setFullbanner() {
  const fullbanners = document.querySelectorAll("[data-fullbanner]");

  fullbanners.forEach((section) => {
    const carousel = section.querySelector(".swiper");
    const pagination = section.querySelector(".swiper-pagination");

    const newFullbanner = new Swiper(carousel, {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      slidesPerView: 1,
      watchOverflow: true,
      speed: 1000,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: pagination,
        type: "bullets",
        clickable: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
    });

    // Prepara a classe com estilos de animação no primeiro slide
    // apenas quando é feito a primeira transição
    newFullbanner.on("slideChangeTransitionEnd", () => {
      const activeSlide = newFullbanner.slides[newFullbanner.activeIndex];
      newFullbanner.slides[0].classList.add("scale-ready");

      // Remove a classe de animação dos slides inativos
      newFullbanner.slides.forEach(
        (slide) => slide !== activeSlide && slide.classList.remove("scaleIn"),
      );
    });

    // Adiciona a classe de animação no slide ativo de acordo com a troca
    newFullbanner.on("slideChange", (event) => {
      const root = document.documentElement;
      const defaultColor = root.style.getPropertyValue(
        "--default-header-menu-color",
      );
      const activeSlide = newFullbanner.slides[newFullbanner.activeIndex];
      activeSlide.classList.add("scaleIn");
      const color = activeSlide.style.getPropertyValue("--fb-color");

      if (activeSlide && color) {
        root.style.setProperty("--header-menu-color", color);
      } else {
        root.style.setProperty("--header-menu-color", defaultColor);
      }
    });

    //Autoplay condicional
    newFullbanner.autoplay.stop();

    const startAutoplay = () => {
      if (!newFullbanner.destroyed) {
        newFullbanner.autoplay.start();
      }
    };

    const eventType = window.mobile ? "scroll" : "mousemove";
    window.addEventListener(eventType, startAutoplay, { once: true });
  });
}
